import { Scene } from 'phaser';
import { TweenAction } from '../core/TweenAction';

export class TileJumpAction extends TweenAction {
  protected x: number;
  protected y: number;
  protected scaleX: number;
  protected scaleY: number;
  protected alpha?: number;

  constructor(scene: Scene, targets: any, duration: number, x: number, y: number, scaleX: number, scaleY: number, alpha?: number) {
    super(scene, targets, duration);
    this.x = x;
    this.y = y;
    this.scaleX = scaleX;
    this.scaleY = scaleY;
    this.alpha = alpha
    this.setYoyo(true);
    this.setEase('Power2');
  }

  protected setTweenConfig() {
    super.setTweenConfig();
    this.setTweenConfigValue('x', this.x);
    this.setTweenConfigValue('y', this.y);
    if(this.alpha) {
      this.setTweenConfigValue('alpha', this.alpha);
    }
    this.setTweenConfigValue('scaleX', this.scaleX);
    this.setTweenConfigValue('scaleY', this.scaleY);
  }
}